import { SlotAnimationConstant, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { IObject } from "@quest/adapter-interface";

export let gameConstants: IObject = {
  GAME_CONTAINER_DIV: "gameContainer",
  COL_COUNT: 5,
  ROW_COUNT: 3,
  DURATION_1220: 1220,
  DURATION_1500 : 1500,
  //Hold And Respin
  HOLD_RESPIN_BG_SHOW: "holdAndRespinBGShow",
  BONUSGAME_SPINEDELAY: "BONUSGAME_SPINEDELAY",
  BONUSGAME_IDLE_SPINE_ID: "bonusgame_idle",
  BONUSGAME_SPINE: "bonusgame_idle",
  //Hold And Respin string constants
  SYMBOL_REEL: "reelContainer_",
  SPIN_ACTIVE_COUNT: "spinActive_",
  COIN_SPINE: "BonusGames_Symbols",
  TIME_BONUS_ANIMATION_END: 2500,
  IPAD: "ipad",
  COLLECT_ALL: "collectAll",
  MULTIPLIER: "multiplier",
  GOLDEN: "golden",
  BIG_PRIZE: "bigPrize",

  // Big Win, Fg Intro & Outro Blur BG
  SHOW_BIG_WIN_BLUR_BG: "SHOW_BIG_WIN_BLUR_BG",
  SHOW_SUPER_WIN_BLUR_BG: "SHOW_SUPER_WIN_BLUR_BG",
  SHOW_EPIC_WIN_BLUR_BG: "SHOW_EPIC_WIN_BLUR_BG",
  SHOW_CRAZY_WIN_BLUR_BG: "SHOW_CRAZY_WIN_BLUR_BG",

  SKULL_MULTIPLIER: 151,
  SKULL_BIG_PRIZE: 152,
  SKULL_COLLECT_ALL: 153,

  CHARACTER_MULTIPLIER: 12,
  CHARACTER_BIG_PRIZE: 13,
  CHARACTER_COLLECT_ALL: 14,
  SYMBOL_WILD: 0,
  SYMBOL_SCATTER: 11,
  SYMBOL_MAN: 1,

  SKULL_GOLDEN: 150,
  SHOW_AMOUNT_SKULL_MULTIPLER: 100,
  STOP_RESPIN_BOUNCE: 20,
  STOP_RESPIN_BOUNCE_TIME: 150,
  STOP_RESPIN_BOUNCE_TIMEOUT: 150,
  ONE_SECOND_DELAY: 1000,
  DELAY_TIME: 300,
  ADDED_POSITION : 10,
  LEFT_IMAGE_HEIGHT: 165,
  // big win threshold
  //big win threshold
  BigWinMultiplier: 10,
  SuperWinMultiplier: 20,
  EpicWinMultiplier: 50,
  CrazyWinMultiplier: 100,
  WINTICKUP_22: 5,

  BONUS_ALLIGN_WITH_BASE_GAME_ON_PORTRAIT: 8,
  BONUS_ALLIGN_WITH_BASE_GAME_ON_PORTRAIT_IPAD: 15,
};
SlotConstantsBehavior.VIEW_SLIDE_MOBILE = 4;
SlotConstantsBehavior.FONT_LIST = ["Arial", "ArialBlack", "MinionPro-Bold", "ArialBold", "Albertus-Nova-W07-Bold"];
SlotConstantsBehavior.REEL_BOTTOM_SPACE = -106;
SlotConstantsBehavior.WINTICKUP_BG_3 = 1.7;
(SlotConstantsBehavior.REEL_BOTTOM_SPACE_LANDSCAPE = -106), (SlotConstantsBehavior.BASEGAME_IDLE_SPINE = "basegame_idle");
SlotConstantsBehavior.FREEGAME_IDLE_SPINE = "freegame_idle";
(SlotConstantsBehavior.FREEGAME_IDLE_SPINE_ID = "background_idle"),
  (SlotConstantsBehavior.FREEGAME_IDLE_PORTRAIT_SPINE_ID = "background_idle_portrait");
SlotAnimationConstant.FG_INTRO_DESKTOP_BG_IN = "in_bg_desktop";
SlotAnimationConstant.FG_INTRO_DESKTOP_BG_STATIC = "loop_bg_desktop";
SlotAnimationConstant.FG_INTRO_DESKTOP_IN = "in";
SlotAnimationConstant.FG_INTRO_DESKTOP_STATIC = "loop";
SlotAnimationConstant.FG_INTRO_DESKTOP_BG_OUT = "out_bg_desktop";
SlotAnimationConstant.FG_INTRO_DESKTOP_OUT = "out";
SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_IN = "in_bg_portrait";
SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_IN = "in_bg_portrait";
SlotAnimationConstant.FG_INTRO_PORTRAIT_IN = "in";
SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_STATIC = "loop_bg_portrait";
SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_OUT = "out_bg_portrait";
SlotAnimationConstant.FG_INTRO_PORTRAIT_OUT = "out";
SlotAnimationConstant.FG_INTRO_PORTRAIT_STATIC = "loop";
SlotAnimationConstant.FG_OUTRO_DESKTOP_BG_IN = "in_bg_desktop";
SlotAnimationConstant.FG_OUTRO_DESKTOP_BG_LOOP = "loop_bg_desktop";
SlotAnimationConstant.FG_OUTRO_DESKTOP_OUT = "out";
SlotAnimationConstant.FG_OUTRO_DESKTOP_OUT_BG = "out_bg_desktop";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_IN = "in_bg_portrait";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_IN = "in";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_OUT = "out_bg_portrait";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_LOOP = "loop_bg_portrait";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_LOOP = "loop";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_OUT = "out";
SlotAnimationConstant.FG_OUTRO_DESKTOP_LOOP = "loop";
SlotAnimationConstant.FG_OUTRO_DESKTOP_IN = "in";
SlotAnimationConstant.FG_BIG_WIN_DESKTOP_START = "In_desktop_fg";
SlotAnimationConstant.FG_BIG_WIN_DESKTOP_LOOP = "Loop_desktop_fg";
SlotAnimationConstant.FG_BIG_WIN_DESKTOP_END = "out_desktop_fg";
SlotAnimationConstant.FG_BIG_WIN_PORTRAIT_START = "In_portrait_fg";
SlotAnimationConstant.FG_BIG_WIN_PORTRAIT_LOOP = "Loop_portrait_fg";
SlotAnimationConstant.FG_BIG_WIN_PORTRAIT_END = "out_portrait_fg";
SlotConstantsBehavior.IPAD_MINI_ASPECT_RATIO = 1.52;